import { useCallback, useEffect, useState } from 'react';
import { buildDropboxExtensions, loadDropboxChooser } from '../utils/dropboxChooser';

const useDropboxChooserButton = ({
  appKey,
  isEnabled,
  acceptedFileTypes,
  multiselect = true,
  isFolderSelectEnabled = false,
  onSuccess
}) => {
  const [dropboxApi, setDropboxApi] = useState(null);
  const [isSupported, setIsSupported] = useState(true);

  useEffect(() => {
    if (!isEnabled) return;
    let isMounted = true;

    loadDropboxChooser(appKey)
      .then((Dropbox) => {
        if (!isMounted) return;
        const supported = Dropbox.isBrowserSupported?.() ?? true;
        setIsSupported(supported);
        if (supported) {
          setDropboxApi(Dropbox);
        }
      })
      .catch((error) => {
        console.error('Error loading Dropbox Chooser:', error);
      });

    return () => {
      isMounted = false;
    };
  }, [appKey, isEnabled]);

  const openChooser = useCallback(() => {
    if (!dropboxApi || !isSupported) return;

    // folderselect only ever returns preview links, and an extension filter cannot describe a folder
    if (isFolderSelectEnabled) {
      dropboxApi.choose({
        linkType: 'preview',
        multiselect,
        folderselect: true,
        success: onSuccess
      });
      return;
    }

    const dropboxExtensions = buildDropboxExtensions(acceptedFileTypes);
    dropboxApi.choose({
      linkType: 'direct',
      multiselect,
      extensions: dropboxExtensions.length ? dropboxExtensions : undefined,
      success: onSuccess
    });
  }, [dropboxApi, isSupported, acceptedFileTypes, multiselect, isFolderSelectEnabled, onSuccess]);

  return {
    openChooser,
    isReady: Boolean(dropboxApi),
    isSupported
  };
};

export default useDropboxChooserButton;
